import React, { memo, useCallback, useMemo, useState, useEffect } from 'react'
import { IFullStop } from 'types'
import { LOAD_STATE } from 'apps/fleet-planner/constants/loads'
import { IStop, ILoad } from 'apps/fleet-planner/types/loads'
import { IExternalPermissions } from 'apps/fleet-planner/types/permissions'
import { getStopNumbers } from 'apps/fleet-planner/utils/stopNumbers'
import { StopInlineEditContainer } from './StopInlineEditContainer'

interface IStopsProps {
  marketplaceStops: IFullStop[]
  stops: IStop[]
  currentEditField?: string
  status: LOAD_STATE
  loadId?: string
  error?: string
  loading?: boolean
  permissions?: IExternalPermissions
  isExternal?: boolean
  onEditModeRequested: (name?: string) => void
  updateLoad: (changes: Partial<ILoad>) => void
}

export const Stops = memo<IStopsProps>(
  ({
    marketplaceStops = [],
    stops: loadStops = [],
    onEditModeRequested,
    currentEditField,
    updateLoad,
    loadId,
    error,
    loading,
    permissions,
    isExternal,
    status,
  }) => {
    const initialState = [...loadStops]
    const [stops, setStops] = useState<IStop[]>(initialState)

    useEffect(() => setStops(loadStops), [loadStops])

    const stopNumbers = useMemo(() => getStopNumbers(stops), [stops.length])

    const onCancelHandler = useCallback(() => {
      setStops(initialState)
      onEditModeRequested('')
    }, [initialState, onEditModeRequested])

    return (
      <>
        {stops.map((stop, idx) => {
          const externalStopId = stop?.externalId ? parseInt(stop?.externalId, 10) : undefined
          const marketplaceStop = marketplaceStops.find(mpStop => mpStop?.id === externalStopId)
          return (
            <StopInlineEditContainer
              status={status}
              marketplaceStop={marketplaceStop}
              key={stop.id}
              isExternal={isExternal}
              permissions={permissions}
              loadId={loadId}
              loading={loading}
              error={error}
              onEditModeRequested={onEditModeRequested}
              currentEditField={currentEditField}
              updateLoad={updateLoad}
              stop={stop}
              stops={stops}
              handleStopChange={setStops}
              sequence={stopNumbers[idx]}
              onCancel={onCancelHandler}
            />
          )
        })}
      </>
    )
  }
)
